module.exports = __webpack_public_path__ + "static/media/device-speed.149b09cc.svg";